"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "savignano-sul-rubicone": {
    "dc97210c": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "aree-urbane-centro-storico": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ae9eae0": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cesare-san-giovanni-in-compito": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "savignano-sul-rubicone"
    }],
    "97955ee4": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "rio-salto": [{
      "hkey": "6487aacd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "savignano-sul-rubicone"
    }],
    "492e2846": [{
      "hkey": "513fda89",
      "slug": "savignano-sul-rubicone",
      "name": "Savignano sul Rubicone",
      "primary": true,
      "skipSearch": false
    }],
    "valle-ferrovia": [{
      "hkey": "513fda89",
      "slug": "savignano-sul-rubicone",
      "name": "Savignano sul Rubicone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;